import { IconProps } from 'src/utils/icon';

const CommunicationIcon: React.FC<IconProps> = ({ size = 1 }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.75 7.5h-15a1.25 1.25 0 000 2.5h15a1.25 1.25 0 000-2.5zM18.75 12.5h-10a1.25 1.25 0 000 2.5h10a1.25 1.25 0 000-2.5z"
      fill="#000"
    />
    <path
      d="M27.5 0H5C2.243 0 0 2.243 0 5v25a1.249 1.249 0 002.05.96L9.203 25H27.5c2.758 0 5-2.242 5-5V5c0-2.757-2.242-5-5-5zM30 20c0 1.378-1.12 2.5-2.5 2.5H8.75c-.293 0-.575.102-.8.29L2.5 27.333V5c0-1.377 1.12-2.5 2.5-2.5h22.5C28.88 2.5 30 3.623 30 5v15z"
      fill="#000"
    />
    <path
      d="M35 10a1.25 1.25 0 000 2.5c1.38 0 2.5 1.123 2.5 2.5v21.148l-4.22-3.376a1.26 1.26 0 00-.78-.272H15c-1.38 0-2.5-1.122-2.5-2.5v-1.25a1.25 1.25 0 00-2.5 0V30c0 2.758 2.242 5 5 5h17.06l5.907 4.727a1.262 1.262 0 001.325.15c.433-.21.708-.647.708-1.127V15c0-2.758-2.242-5-5-5z"
      fill="#000"
    />
  </svg>
);

export default CommunicationIcon;
